import React from 'react';
import useTitle from '../useTitle';

const Cursoprompt = () => {

    useTitle("Curso Prompt Engineering");

    return (
        <React.Fragment>
        <header 
            className="w3-container w3-center w3-padding-64 w3-black w3-light-grey w3-margin-64" 
            style={{ marginBottom: '-64px' }}
        >
            <h1><b>Curso de Prompt Engineering</b></h1>
            <img src="logo-gif-1.gif" alt="Aprender IA Logo" style={{ width: '200px' }} />
            <h3><b>¿Qué es el Prompt Engineering?</b></h3>
            <div 
                className="w3-container w3-center" 
                style={{ margin: '0 auto', width: '80%' }}
            >
                <p className="w3-xlarge">Es el proceso de crear instrucciones(prompts) y de estructurarlas adecuadamente para que los modelos de inteligencia artificial generativa proporcionen el mejor resultado posible. El término que podemos usar en español es <b>ingeniería de instrucciones</b>(<b>ingeniería de prompts</b>).</p>
                <p className="w3-xlarge">¿Listo para empezar?<br />⬇️⬇️⬇️</p>
            </div>
        </header>

        <section style={{ position: 'relative' }}>
            <div className="custom-shape-divider-bottom-1748065471">
                <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M598.97 114.72L0 0 0 120 1200 120 1200 0 598.97 114.72z" className="shape-fill"></path>
                </svg>
            </div>
        </section>

        {/* Blog entries row 1 */}
        <div 
            className="w3-container w3-center w3-margin-32 w3-padding-32 w3-flex w3-black" 
            style={{ flexWrap: 'wrap', justifyContent: 'center' }}
        >
            <div className="w3-card-4 w3-third">
                <div className="w3-container livecard">
                    <iframe 
                        className="yt-video card-image" 
                        src="https://www.youtube.com/embed/rnnQRp_TZyk" 
                        title="YouTube video player" 
                        frameBorder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                        referrerPolicy="strict-origin-when-cross-origin" 
                        allowFullScreen
                    ></iframe>
                    <h3><b>Introducción</b></h3>
                    <h5>VIDEO 1</h5>
                </div>
            </div>

            <div className="w3-card-4 w3-third">
                <div className="w3-container livecard">
                    <iframe 
                        className="yt-video card-image" 
                        src="https://www.youtube.com/embed/FROelfEu5kg" 
                        title="YouTube video player" 
                        frameBorder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                        referrerPolicy="strict-origin-when-cross-origin" 
                        allowFullScreen
                    ></iframe>
                    <h3><b>Primeras Técnicas</b></h3>
                    <h5>VIDEO 2</h5>
                </div>
            </div>

            <div className="w3-card-4 w3-third">
                <div className="w3-container livecard">
                    <iframe 
                        className="yt-video" 
                        src="https://www.youtube.com/embed/GyO-oY3Lk-g" 
                        title="YouTube video player" 
                        frameBorder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                        referrerPolicy="strict-origin-when-cross-origin" 
                        allowFullScreen
                    ></iframe>
                    <h3><b>Dejar pensar al LLM</b></h3>
                    <h5>VIDEO 3</h5>
                </div>
            </div>
        </div>

        {/* Blog entries row 2 */}
        <div 
            className="w3-container w3-center w3-flex w3-black w3-margin-64" 
            style={{ justifyContent: 'center' }}
        >
            <div className="w3-card-4 w3-third">
                <div className="w3-container livecard">
                    <iframe 
                        className="yt-video" 
                        src="https://www.youtube.com/embed/4nmm8nhc4Qk" 
                        title="YouTube video player" 
                        frameBorder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                        referrerPolicy="strict-origin-when-cross-origin" 
                        allowFullScreen
                    ></iframe>
                    <h3><b>Desarrollo por etapas</b></h3>
                    <h5>VIDEO 4</h5>
                </div>
            </div>

            <div className="w3-card-4 w3-third">
                <div className="w3-container livecard">
                    <iframe 
                        className="yt-video" 
                        src="https://www.youtube.com/embed/h-NdT9C5dzk" 
                        title="YouTube video player" 
                        frameBorder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                        referrerPolicy="strict-origin-when-cross-origin" 
                        allowFullScreen
                    ></iframe>
                    <h3><b>Deducir sentimientos</b></h3>
                    <h5>VIDEO 5</h5>
                </div>
            </div>
        </div>
        </React.Fragment>
    );
};

export default Cursoprompt;